document.addEventListener('DOMContentLoaded', function () {
    const lgBreakpoint = window.matchMedia('(min-width: 1024px)');

    if (lgBreakpoint.matches) {
      const cards = document.querySelectorAll('.opacityTrick');

      if (cards.length > 0) {
        cards.forEach((card) => {
          card.addEventListener('mouseenter', () => {
            cards.forEach((c) => {
              if (c !== card) {
                c.style.opacity = '0.5';
              }
            });
          });

          card.addEventListener('mouseleave', () => {
            cards.forEach((c) => {
              c.style.opacity = '1';
            });
          });
        });
      }
    }
});